import { RxCross2 } from "react-icons/rx";
import ModalUI from "./components/ModalUI";
import { useEffect, useState } from "react";
import { useCookieHandler } from "./components/hooks/cookie";
import ReactGA from "react-ga4";
import { AnimatePresence } from "framer-motion";
function useIsClient() {
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);
  
  return isClient;
} 
function CookiesModal() {
      const isClient = useIsClient();
    const [showModal, setShowModal] = useState(false);
  const { cookies, handleAccept, handleReject } = useCookieHandler();
  const [showCookieBarAfterModal, setShowCookieBarAfterModal] = useState(true);

  const [isCookieBar, setIsCookieBar] = useState(false);
  
  useEffect(() => {
    if (!isClient) return;
    
    if (cookies.userInteracted === false) {
      setIsCookieBar(true);
    } else {
      setIsCookieBar(false);
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
      }
    }
  }, [cookies.userInteracted, isClient]);

  const modalHandler = () => {
    setShowModal(!showModal);
  };
  const cookiebarHandler = () => {
    localStorage.setItem("cookieAccepted", "true");
    handleAccept();
    setIsCookieBar(false); 
  };
  const rejectCookiesHandler = () => {
    handleReject();
  };
  useEffect(() => {
        if (!isClient) return;

    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showModal,isClient]);

  const consent = cookies.analyticsAllowed;

  useEffect(() => {
    // console.log("Cookie value:", cookies.analyticsAllowed);
    if (!isClient) return;

    if (consent === false) {
      // console.log("GA BLOCKED (user rejected)");
      // console.log("GA Disabled"); 
      ReactGA.gtag("consent", "update", { 
        analytics_storage: "denied",
      }); 
      return; 
    } else if (consent === true ) {
      // console.log("GA INITIALIZED");
if (typeof window !== "undefined") {
  setTimeout(() => {
    ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, 2000);
}     
    }
  }, [cookies.analyticsAllowed,isClient]);

  // useEffect(() => {
    
  //   if(cookies.userInteracted ===false){
      
  //     setIsCookieBar(true);
  //   }else{
  //     setIsCookieBar(false);
  //           document.body.style.overflow = "";

      
  //   }
  // }, [cookies.userInteracted]);
  return (
    <>
          <AnimatePresence
           onExitComplete={() => {
        // Show cookie bar after modal fully closes
        // if (!isCookieBar) {setShowCookieBarAfterModal(true)};
      }}>
      {isCookieBar && showModal && (
            <ModalUI
              modalHandler={modalHandler}
              />
            )

       }
      </AnimatePresence>
        {isCookieBar  &&(
          <div
            className={` md:px-4 xl:px-10  bg-white md:max-h-28  py-3 space-y-3 md:space-y-0 md:space-x-10 border-t-2 fixed bottom-0  ${!showModal ?  "block" :"hidden" } w-full z-[99999999999999]`}
          >
          {/* <button
            className="border2 px4 py2 w-fit inline-block md:hidden self-end "
            onClick={cookiebarHandler}
          >
            <RxCross2 />
          </button> */}
          <div className="  flex flex-col md:flex-row justify-center items-center space-y-3 md:space-y-0 md:space-x-1 lg:space-x-8 xl:space-x-10">
            <div className="w-full md:w-6/12 lg:w-6/12 xl:w-auto  px-4 ">
              <p className="text-sm md:text-[13px] lg:text-sm">
                We use cookies to personalize content, to provide social media
                features, and to analyze our traffic. We also share information
                about your use of our site with our social media and analytics
                partners.
              </p>
            </div>
            <div className="  md:space-y-0  flex flex-row gap-2 justify-start w-full md:w-auto px-4">
              <button
                className="bg-[#df73ff]   px-4 md:px-8 py-0 md:py-2 text-xs lg:text-sm"
                onClick={cookiebarHandler}
                aria-label="Accept cookies button"
              >
                Accept
              </button>
              <button
                className="border-2 px-4 md:px-8 py-0 md:py-2 text-xs lg:text-sm md:min-w-[180px] lg:min-w-[200px] "
                onClick={modalHandler}
                aria-label="Manage Preferences"
              >
                Manage Preferences
              </button>
              <button
                className="border-2 px-2 md:px-4 py-2 "
                onClick={rejectCookiesHandler}
                aria-label="Close"
              >
                <RxCross2 />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default CookiesModal;
